import theme from './theme'
// func
import { throttle } from '_u/helper'
import createSocketClient from '_u/create-socket-client'
// api
import { insideBI, orderListForInsideBI } from '@/api/order-manage'

export default {
    mixins: [theme],

    props: {
        // 上屏工单类型
        queryCfg: {
            type: String,
            default: '1,2,3,5,6,7', // 所有工单状态
        },
    },

    data() {
        return {
            // 状态数据
            init: false,
            stompClient: null,
            topicSub: null,
            // 工单统计
            overviewByYear: {},
            overviewByMonth: {},
            serviceTypeCountByYear: [],
            serviceTypeCountByMonth: [],
            serviceTypeStatusByYear: [],
            serviceTypeStatusByMonth: [],
            serviceTypeStatusFullYear: [],
            // 工单列表
            orderStatus: this.$dict.NULL,
            newOrders: [],
            reciveOrders: [],
            assignedOrders: [],
            orderList: [],
            orderBuffer: [],
            // 工单滚动播放
            feq: 0,
            batchRefresh: false,
            batchId: '',
            batchTimer: null,
            batchNum: -1,
            batchOrder: [],
            batchSize: 6,
        }
    },

    created() {
        this.$dict.get(['order_status', 'service_type'])
            .then(dictGroup => {
                this.orderStatus = dictGroup.orderStatus
                this.init = true
            })
            .then(() => this.fetch())
            .then(() => this.connect())
    },

    beforeDestroy() {
        this.disconnect()
        this.stopSwitch()
    },

    computed: {
        wsTopic() {
            return this.$store.state.user.info.wsTopic
        },

        toReceiveCount() {
            return this.newOrders.length + this.reciveOrders.length
        },
    },

    watch: {
        orderList(val) {
            this.feq++

            // 更新缓冲区, 优先展示新来工单
            if (this.newOrders.length) {
                this.orderBuffer = val.slice(0, Math.ceil(this.newOrders.length / this.batchSize) * this.batchSize)
            } else {
                this.orderBuffer = val
            }

            // 工单滚动控制
            if (this.batchTimer) {
                // 下一页重新开始滚动
                this.batchRefresh = true
            } else {
                // 首屏
                this.switchOrderList()
                this.startSwitch()
            }
        },
    },

    methods: {
        // 建立socket连接
        connect() {
            var topicLine = `/topic/notify/${this.wsTopic}`,
                vm = this

            //请求连接
            this.stompClient = createSocketClient({
                url: this.isDev ? '/ws/websocket' : process.env.VUE_APP_SERVER + 'websocket',
            }).$on('connect', () => {
                this.topicSub = this.stompClient.subscribe(
                    topicLine,
                    function(response) {
                        var result = JSON.parse(response.body)

                        if (result) {
                            console.log("工单刷新")
                            vm.refresh()
                        }
                    }
                )
            })
        },

        // 取消连接
        disconnect() {
            if (this.topicSub) {
                this.topicSub.unsubscribe()
                this.topicSub = null
            }

            if (this.stompClient) {
                this.stompClient.disconnect()
                this.stompClient = null
            }
        },

        // 取消顶雀
        unsubscribe() {
            this.topicSub.unsubscribe()
        },

        // 开启工单滚动
        startSwitch(){
            this.stopSwitch()
            this.batchTimer = setInterval(this.switchOrderList, 8000)
        },

        // 停止工单滚动
        stopSwitch(){
            if (this.batchTimer) {
                clearInterval(this.batchTimer)
            }
        },

        // 获取数据
        fetch() {
            // 工单列表
            return Promise.all([
                // 图表统计数据
                insideBI({
                    indicator: 'overviewByMonth,overviewByYear,serviceTypeCountByMonth,serviceTypeCountByYear,serviceTypeStatusByMonth,serviceTypeStatusByYear,serviceTypeStatusFullYear',
                }),
                // 工单列表
                orderListForInsideBI({
                    pageNo: 1,
                    pageSize: 999999,
                    orderStatus: this.queryCfg,
                }),
            ]).then(args => {
                var [bi, orders] = args

                var biData = bi.data
                this.overviewByYear = biData.overviewByYear[0] || {}
                this.overviewByMonth = biData.overviewByMonth[0] || {}
                this.serviceTypeCountByYear = biData.serviceTypeCountByYear || []
                this.serviceTypeCountByMonth = biData.serviceTypeCountByMonth || []
                this.serviceTypeStatusByYear = biData.serviceTypeStatusByYear || []
                this.serviceTypeStatusByMonth = biData.serviceTypeStatusByMonth || []
                this.serviceTypeStatusFullYear = biData.serviceTypeStatusFullYear || []

                var newOrders = [],
                    reciveOrders = [],
                    assignedOrders = []

                orders = orders.data.page.list || []
                orders.forEach(v => {
                    // 待派单
                    if (v.orderStatus == '1') {
                        return newOrders.push(v)
                    }

                    // 待接收
                    if (v.orderStatus == '2') {
                        assignedOrders.push(v)
                        reciveOrders.push(v)
                        return
                    }

                    // 已分配
                    assignedOrders.push(v)
                })

                this.newOrders = newOrders
                this.reciveOrders = reciveOrders
                this.assignedOrders = assignedOrders
                this.orderList = [...newOrders, ...assignedOrders]
            })
        },

        // 刷新数据
        refresh: throttle(5000, function() {
            this.fetch()
        }),

        // 切换工单列表
        switchOrderList() {
            var totalCount = Math.ceil(this.orderBuffer.length / this.batchSize)

            // 缓冲区有更新，从头开始循环
            if (this.batchRefresh) {
                this.batchNum = 0
                this.batchRefresh = false
            } else {
                this.batchNum = ++this.batchNum % totalCount
            }

            this.batchId = 'i' + this.feq + this.batchNum
            this.batchOrder = this.orderBuffer.slice(this.batchNum * this.batchSize, (this.batchNum + 1) * this.batchSize)
        },

        // 跳转首页
        backHome() {
            if (this.$aliveTab.tabs.length > 1) {
                this.$router.back()
            } else {
                this.$router.replace({
                    name: this.$config.homeName
                })
            }
        },
    }
}